import { useQuery } from "react-query";
import LoadingApiClient from "api/LoadingApiClient";

export function useMunicipalityLoading(municipalityId) {
    return useQuery(["MunicipalityLoading", { municipalityId }], () =>
        LoadingApiClient.getMunicipalityLoading(municipalityId),
    );
}
